import Header from "../layout/header";
import { useAppSelector } from "../../store/store";
import { Typography } from "@material-ui/core";
import { Box } from "@mui/material";

export default function SsoDisabled() {
      
  return (
    <Box>
      <img
        src="assets/images/account-freezed-image.png"
        alt=""
        style={{
          height: "50%",
          width: "30%",
          minWidth: "400px",
          display: "block",
          margin: "0 auto",
        }}
      />
      <h2 style={{ textAlign: "center" }}>
        Your Tenant SSO Setting is off, so you can't see anything right now.
        please login with your username and password.
      </h2>
    </Box>
  );
}
